import Mexp from 'math-expression-evaluator';


//If a value can be parsed into a float, normalize it.
//Otherwise try to eval as a mathematical expression.
//If it fails, return the original value
export function evalOrNormalize(value: string): string {
    if (!value) return value;

    if (isFloat(value)) {
        return normalizeFloat(value);
    } else {
        return attemptEval(value);
    }
}

//If a value has less than 2 decimals, add them. If starts in a period, add leading zero
export function normalizeFloat(value: string): string {
    if (!value) return value;

    let newValue = value.replace(/^\+/, '');//Remove leading plus
    const numDecimals = newValue.split('.')[1]?.length || 0;
    if (numDecimals < 2) {
        newValue = (+newValue).toFixed(2);
    }
    if (newValue.startsWith('.')) {
        newValue = '0' + newValue;
    }
    return newValue;
}

export function isFloat(value: string): boolean {
    if (!value) return false;
    return !isNaN(+value);
}

//Eval a string as a mathematical expression
function attemptEval(value: string): string {
    try {
        const mexp = new Mexp();
        const preparedValue = value.replaceAll('**', '^');
        const result = mexp.eval(preparedValue);
        return typeof result === 'number' && isFinite(result)
            ? result.toFixed(2)
            : value;
    } catch {
        return value;
    }
}
